/**
 * Rutas Públicas
 * Estas rutas no requieren autenticación (login) o tienen su propio guard (PDA)
 */
import { Route } from 'react-router-dom'
import Login from '../pages/Login.jsx'
import ScanQR from '../pages/mobile/scan/ScanQR.jsx'
import ProtectedRoute from '../components/ProtectedRoute.jsx'
import SalaMezclaPDA from '../pages/produccion/traceability/pda/SalaMezclaPDA.jsx'

export const publicRoutes = [
  <Route key="login" path="/login" element={<Login />} />,
  <Route key="scan-qr" path="/mobile/scan" element={<ScanQR />} />,
  // PDA sin Layout MES; auth vía Authentik (ProtectedRoute)
  // Soporta /pda/sala-mezcla?factory=CXC y /CXC/pda/sala-mezcla
  <Route
    key="pda-sala-mezcla"
    path="/pda/sala-mezcla"
    element={
      <ProtectedRoute>
        <SalaMezclaPDA />
      </ProtectedRoute>
    }
  />,
  <Route
    key="pda-sala-mezcla-factory"
    path="/:factory/pda/sala-mezcla"
    element={
      <ProtectedRoute>
        <SalaMezclaPDA />
      </ProtectedRoute>
    }
  />,
]

